const config = {
  appVersion: 1.4,
  startDate: "2024-04-11", // yyyy-mm-dd
  gameGuesses: 5
};

export default config;
